exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div {\n  margin: 6px 0;\n  padding: 0;\n  color: #FFFFFF;\n  font-size: 11px;\n  line-height: 11px; }\n\nem {\n  color: #929292;\n  font-style: normal;\n  font-weight: normal; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/power-planner/power-planner/src/app/page-main.module/account-level.component/account-level.component.scss
// module id = ../../../../../src/app/page-main.module/account-level.component/account-level.component.scss
// module chunks = main